import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`display:flex;flex-direction:column;gap:6px;`;
const Label = styled.label`
  font-size:${p => p.theme.typography.sizes.sm};
  font-weight:${p => p.theme.typography.weights.semibold};
  color:${p => p.theme.colors.text.primary};
`;
const Row = styled.div`display:flex;gap:8px;align-items:center;flex-wrap:wrap;`;
const Select = styled.select`
  padding:8px 12px;
  border:1px solid ${p => p.theme.colors.border};
  border-radius:${p => p.theme.radius.md}px;
  font-size:${p => p.theme.typography.sizes.md};
  font-family:${p => p.theme.typography.monoFamily};
  background:${p => p.theme.colors.surface};
  cursor:pointer;min-width:60px;min-height:44px;
  &:focus{border-color:${p => p.theme.colors.primary};outline:none;box-shadow:0 0 0 2px rgba(108,99,255,0.15);}
  &:disabled{opacity:0.5;cursor:not-allowed;}
`;
const ToggleLink = styled.button`
  background:none;border:none;
  color:${p => p.theme.colors.primary};
  cursor:pointer;font-size:${p => p.theme.typography.sizes.xs};
  text-decoration:underline;padding:0;margin-left:auto;
`;

export function to24Hour(hour, period, timeFormat) {
  if (timeFormat === '24h') return hour;
  if (period === 'AM') return hour === 12 ? 0 : hour;
  return hour === 12 ? 12 : hour + 12;
}

export default function TimeInput({
  hour, minute, period = 'AM', timeFormat: tfProp,
  onHourChange, onMinuteChange, onPeriodChange, onFormatChange,
  label = 'Time', disabled = false,
}) {
  const [format, setFormat] = useState(() => tfProp || localStorage.getItem('vedic_time_format') || '12h');

  useEffect(() => {
    localStorage.setItem('vedic_time_format', format);
    if (onFormatChange) onFormatChange(format);
  }, [format, onFormatChange]);

  const toggleFormat = () => {
    const next = format === '12h' ? '24h' : '12h';
    setFormat(next);
  };

  const hours = format === '12h'
    ? Array.from({ length: 12 }, (_, i) => i + 1)
    : Array.from({ length: 24 }, (_, i) => i);

  return (
    <Wrapper>
      <Label>{label}</Label>
      <Row>
        <Select value={hour} onChange={e => onHourChange(Number(e.target.value))} disabled={disabled}>
          {hours.map(h => <option key={h} value={h}>{String(h).padStart(2, '0')}</option>)}
        </Select>
        <span>:</span>
        <Select value={minute} onChange={e => onMinuteChange(Number(e.target.value))} disabled={disabled}>
          {Array.from({ length: 60 }, (_, i) => i).map(m => (
            <option key={m} value={m}>{String(m).padStart(2, '0')}</option>
          ))}
        </Select>
        {format === '12h' && (
          <Select value={period} onChange={e => onPeriodChange(e.target.value)} disabled={disabled}>
            <option value="AM">AM</option>
            <option value="PM">PM</option>
          </Select>
        )}
        <ToggleLink type="button" onClick={toggleFormat}>
          Switch to {format === '12h' ? '24h' : '12h'}
        </ToggleLink>
      </Row>
    </Wrapper>
  );
}
